import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Detail } from "@ane/ui-components/lib/components/Detail";
import { GridCol, GridRow } from "@ane/ui-components/lib/components/Grid";
import _ from "lodash";
import { DataLocationStorageType } from "../../../DataSourceCreate/models/DataSourceDataCommon.js";
var LocationKeyDetailLabel = /* @__PURE__ */ ((LocationKeyDetailLabel2) => {
  LocationKeyDetailLabel2["VC"] = "VC";
  LocationKeyDetailLabel2["DataPath"] = "Data path";
  LocationKeyDetailLabel2["EndPoint"] = "End Point";
  LocationKeyDetailLabel2["Cluster"] = "Cluster";
  LocationKeyDetailLabel2["Url"] = "Key vault URL";
  LocationKeyDetailLabel2["SecretName"] = "Secret name";
  LocationKeyDetailLabel2["ServicePrincipalName"] = "Service principal name";
  LocationKeyDetailLabel2["StorageAccount"] = "Storage account";
  LocationKeyDetailLabel2["Container"] = "Container";
  LocationKeyDetailLabel2["RetentionDays"] = "Retention days";
  LocationKeyDetailLabel2["RetentionDaysErrorMsg"] = "Message for invalid data period";
  LocationKeyDetailLabel2["ManagedIdentityName"] = "Managed identity name";
  return LocationKeyDetailLabel2;
})(LocationKeyDetailLabel || {});
const locationWidth = {
  VC: {
    xl: 2,
    lg: 2,
    md: 3
  },
  DataPath: {
    xl: 6,
    lg: 6,
    md: 6
  },
  EndPoint: {
    xl: 6,
    lg: 6,
    md: 6
  },
  RetentionDays: {
    xl: 6,
    lg: 6,
    md: 6
  },
  RetentionDaysErrorMsg: {
    xl: 6,
    lg: 6,
    md: 6
  },
  Cluster: { xl: 3, lg: 4, md: 5 },
  StorageAccount: { xl: 2, lg: 2, md: 3 },
  Container: { xl: 2, lg: 2, md: 3 },
  SecretName: { xl: 2, lg: 2, md: 3 },
  ServicePrincipalName: { xl: 2, lg: 2, md: 3 },
  Url: { xl: 4, lg: 4, md: 6 },
  ManagedIdentityName: { xl: 2, lg: 2, md: 3 }
};
class DataSourceLocationView extends React.Component {
  render() {
    const data = this.props.dataSource;
    let res = [];
    let resKeyVault = [];
    let items = {};
    if (data == null ? void 0 : data.StorageType) {
      if (data.StorageType === DataLocationStorageType.Cosmos) {
        items = data.CosmosLocation;
      } else if (data.StorageType === DataLocationStorageType.AzureBlob) {
        items = data.AzureBlobLocation;
      } else if (data.StorageType === DataLocationStorageType.ADLSGen2) {
        items = data.ADLSGen2Location;
      }
      _.each(items, (item, key) => {
        if (!!item && key === "KeyVaultAuthentication") {
          resKeyVault.push(this._getDetailGridCol("SecretName", item.SecretName));
          resKeyVault.push(this._getDetailGridCol("Url", item.Url));
        } else if (!!item && key !== "DataPath") {
          res.push(
            /* @__PURE__ */ jsx(
              GridCol,
              {
                xl: locationWidth[key].xl,
                lg: locationWidth[key].lg,
                md: locationWidth[key].md
              },
              `${key}GridCol`
            )
          );
        }
      });
    }
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsxs(GridRow, { children: [
        /* @__PURE__ */ jsx(GridCol, { xl: "2", lg: "2", md: "3", children: /* @__PURE__ */ jsx(Detail, { label: "Data type", value: `${data == null ? void 0 : data.StorageType}` }) }),
        res
      ] }),
      /* @__PURE__ */ jsxs(GridRow, { children: [
        resKeyVault.length > 0 && resKeyVault,
        /* @__PURE__ */ jsx(GridCol, { xl: locationWidth.DataPath.xl, lg: locationWidth.DataPath.lg, md: locationWidth.DataPath.md, children: /* @__PURE__ */ jsx(Detail, { label: "Data path", value: items == null ? void 0 : items.DataPath }) })
      ] })
    ] });
  }
  _getDetailGridCol(key, item) {
    return /* @__PURE__ */ jsx(GridCol, { xl: locationWidth[key].xl, lg: locationWidth[key].lg, md: locationWidth[key].md, children: /* @__PURE__ */ jsx(Detail, { label: LocationKeyDetailLabel[key], value: `${item}` }) }, `${key}GridCol`);
  }
}
export {
  LocationKeyDetailLabel,
  DataSourceLocationView as default
};
//# sourceMappingURL=DataSourceLocation.js.map
